import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const primaryColor = '#e20026';
const hoverPrimaryColor = '#a9001c';
const highlightColor = '#fafafa';
const tableHeaderColor = '#f8f7f7';

export const CustomPrimeTheme = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          700: '{sky.800}',
          color: primaryColor,
          hoverColor: hoverPrimaryColor,
        },
        highlight: {
          background: primaryColor,
          focusBackground: hoverPrimaryColor,
          color: highlightColor,
          focusColor: highlightColor,
        },
      },
    },
  },
  components: {
    datatable: {
      headerCell: {
        background: tableHeaderColor,
      },
    },
    togglebutton: {
      colorScheme: {
        light: {
          root: {
            checkedColor: 'white',
            background: 'white',
            padding: '0',
          },
          content: {
            checkedBackground: '{primary.700}',
            padding: '0.5rem',
            borderRadius: '0',
          },
        },
      },
    },
    inputnumber: {
      colorScheme: {
        light: {
          button: {
            background: primaryColor,
            hoverBackground: hoverPrimaryColor,
            activeBackground: hoverPrimaryColor,
          },
        },
      },
    },
  },
});
